/* eslint-disable func-names */

import Window_Level from './Window_level';
import { Window_FillRateFallback } from './Window_FillRateFallback';
import OMT_UI_SquareButton, { BUTTONCOLOURS } from '../../OMT_UI/OMT_UI_SquareButton';

/**
 * Class for pre-level screen for the daily challenge
 */
class Window_dailyChallenge extends Window_Level {
  /**
   * setup level data
   * @param {*} level
   */
  // the level passed here is actually the data, not just the level index (different from Window_level)
  _manageData(level) {
    // this is needed for the levelWindowOpen signal and this function is run before thats dispatched in Window_level
    this.isDailyChallenge = true;
    this._parentLevelName = 'dailyChallenge';
    // set global level data
    if (level !== undefined) {
      // when we get level the first time, its an object, but if we go to the shop and come back, its a number, so we check for both.
      if (typeof level === 'number') {
        G.lvlData = G.Helpers.levelDataMgr.getLevelByIndex(level);
      }
      else {
        G.lvlData = level;
      }
      this.levelData = G.lvlData;
      G.lvlNr = this.levelData.levelNumber;
    }
    this._parentLevelName = 'level';
    this.dailyChallengeLevel = this.levelData.levelIndex;
  }

  /**
   * init the generic graphics layout
   */
  _initLayout() {
    this.rewardedPlayActive = G.saveState.data.rewardedChallenge;
    super._initLayout(OMT.language.getText('Daily Challenge'));
  }

  /**
   * init window buttons
   */
  _initButtons() {
    super._initButtons(BUTTONCOLOURS.orange, this._onContinueClick);

    // _continueBtn is defined in super._initButtons
    this._continueBtn.visible = G.saveState.isChallengeAvailable() || this.rewardedPlayActive;

    this._makeAdContinueButton();
  }

  _makeAdContinueButton() {
    const onAdSuccess = () => {
      G.saveState.enableRewardedChallenge();
      this.adBtn.visible = false;
      this._continueBtn.visible = true;
      this.rewardedPlayActive = true;
    };
    // this.adBtn = new Phaser.Group(G.Game, null);
    // this.adBtn.y = 300;
    const adClick = () => {
      if (!this.adBtn.input.enabled) { return; }
      // do something
      sdkHandler.trigger('rewardedAd', {
        callback:  (success) => {
          console.log("exito", success)
          if (success) { onAdSuccess() }
          else { 
            new Window_FillRateFallback(undefined, {
              placement: G.BuildEnvironment.adPlacements.redoMission,
              callback: onAdSuccess,
              onExit: () => {},
              context: this,
            });
          }
        }
      }, this);
      // OMT.ads.showAd(
      //   G.BuildEnvironment.adPlacements.redoMission,
      //   onAdSuccess,
      //   () => {
      //     if (!G.IAP) { // no IAPS dont use ad fallbacks
      //       // eslint-disable-next-line no-new
      //       new Window_FillRateFallback(undefined, {
      //         placement: G.BuildEnvironment.adPlacements.redoMission,
      //         callback: onAdSuccess,
      //         onExit: () => {},
      //         context: this,
      //       });
      //     } else { // open ad fallback
      //       if (this._rh_tutorialManager) {
      //         this._rh_tutorialManager.toggleVisibility(false);
      //       }
      //       OMT.ads.showAdFallback(() => {
      //         if (this._rh_tutorialManager) {
      //           this._rh_tutorialManager.toggleVisibility(true);
      //         }
      //         onAdSuccess();
      //       });
      //     }
      //   },
      // );
    };
    const adImg = G.makeImage(0, 0, 'btn-movie-icon', 0.5, null);
    this.adBtn = new OMT_UI_SquareButton(0, this._continueBtn.y, {
      button: {
        tint: BUTTONCOLOURS.purple,
        dimensions: {
          width: 309,
          height: 100,
        },
      },
      text: {
        string: OMT.language.getText('Continue'),
        textStyle: { style: 'font-white', fontSize: 40, align: 'center' },
        icon: {
          image: adImg,
          offset: {
            x: adImg.width / 2,
          },
          align: 'left',
        },
      },
      options: {
        clickFunction: {
          onClick: adClick.bind(this),
        },
        pulse: 1.1,
      },
    });
    this.registerButtons(this.adBtn);
    this._levelContainer.add(this.adBtn);
    this.adBtn.visible = !G.saveState.isChallengeAvailable() && (OMT.feature.rewardedAdsAvailable() && !this.rewardedPlayActive);
  }

  /**
   * display stars achived
   */
  _initStars() {
    super._initStars(G.saveState.getChallengeStars());
  }

  /**
   * init task UI
   */
  _initTasks() {
    super._initTasks(this.levelData);
  }

  /**
   * init booster and booster UI
   * @param {number} optLvlIndex
   * @param {Object} requestHelpData
   */
  _initBoosters(requestHelpData) {
    // commented out because it was breaking pre-booster activation
    // this.dailyChallengeLevel = 999;
    // we pass in that true at the end so the boosters know its a daily challenge level
    super._initBoosters(requestHelpData, this.dailyChallengeLevel, null, true);
  }

  /**
   * override treasure hunt setup and disable it
   */
  _setupTreasureHunt() {
    // Just don't
  }

  /**
   * on continue button clicked
   */
  _onContinueClick() {
    super._rh_closeTutorial(true);
    this.rewardedPlayActive = false;

    const dateNow = new Date();
    const lastTryDate = new Date(G.saveState.data.lastChallengeTry);
    if (dateNow.toDateString() !== lastTryDate.toDateString()) {
      OMT.notifications.scheduleGameTriggeredMessage(
        OMT.envData.settings.user.userId,
        'DailyChallenge',
        G.saveState.getTimeToNextChallenge() / 1000,
        null,
        false,
      );
    }

    G.saveState.startChallenge();
    G.sb('onDailyChallengeStart').dispatch();
    const levelData = {
      // removed this because it was just undefined
      // lvlIndex: this.dailyChallengeLevel,
      lvlIndex: this._lvlIndex,
      debugMode: false,
      startBoosters: super._assembleLevelBoosters(this.dailyChallengeLevel),
      challengeLvl: this.levelData,
      preLevelTrackingData: { requestHelp: super._rh_assembleTrackingData() },
    };
    G.sb('onStateChange').dispatch('Game', levelData);
  }
}

// create global references
if (!window.Windows) window.Windows = {};
Windows.dailyChallenge = Window_dailyChallenge;
